<div class="mx-auto md:mx-6 md:max-w-7xl md:rounded-lg md:bg-white md:p-16 xl:mx-auto" *transloco="let t; read: 'findMyAgent.results'">
  @if (store.loading$ | async) {
    <h2 class="mb-4 mt-8 text-3xl font-bold sm:text-4xl lg:mt-12">{{ t('loading') }}</h2>
    @for (x of [].constructor(3); track x) {
      <rma-skeleton class="mb-4 grid !grid-cols-1" [bones]="1" />
    }
  }

  @if (store.results$ | async; as results) {
    @if (results.length > 0) {
      @if (store.resultsState$ | async; as state) {
        @if (store.propertyTypeLabel$ | async | transloco; as propertyTypeLabel) {
          @if (store.locality$ | async; as locality) {
            @if (store.view$ | async; as view) {
              <div class="mb-8 flex flex-col justify-between gap-x-8 lg:flex-row lg:items-end">
                <div class="self-end lg:hidden">
                  <button (click)="onToggleView(view)" mat-stroked-button color="primary" type="button">
                    <rma-icon class="mr-2" [glyph]="view === 'table' ? 'view_stream' : 'format_list_bulleted'" />
                    {{ view === 'table' ? t('block-view') : t('table-view') }}
                  </button>
                </div>
                @if (showHeader$ | async) {
                  <div>
                    <h2 class="mb-4 mt-8 text-3xl font-bold sm:text-4xl lg:mt-12">{{ t('title') }}</h2>
                    <p [innerHTML]="t('explainer', { locality: locality.label })"></p>
                    <p class="hidden md:block" [innerHTML]="t('subtitle', { propertyType: propertyTypeLabel | lowercase })"></p>
                  </div>
                }
                <div class="hidden lg:block">
                  <mat-button-toggle-group
                    class="xs:w-fit w-full"
                    [value]="view"
                    [hideSingleSelectionIndicator]="true"
                    (valueChange)="store.setView($event)">
                    <mat-button-toggle class="xs:!px-4 w-full" value="block" data-id="block-view">
                      <div class="flex items-center"><rma-icon class="mr-2" glyph="view_stream" />{{ t('block-view') }}</div>
                    </mat-button-toggle>
                    <mat-button-toggle class="flex w-full items-center md:!px-4" value="table" data-id="table-view">
                      <div class="flex items-center"><rma-icon class="mr-2" glyph="format_list_bulleted" />{{ t('table-view') }}</div>
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </div>
            }
          }
        }
        @if ((store.view$ | async) === 'block') {
          <div class="space-y-16">
            @for (result of results; track agentsTrackBy($index, result)) {
              <rma-result
                class="flex flex-col"
                [id]="result.profileCode"
                [agent]="result"
                [locality]="state.locality"
                [activeLocality]="state.activeLocality"
                [showActivity]="result.showActivity"
                [showAttribution]="result.showAttribution"
                (seletedLocality)="store.patchState({ activeLocality: $event })"
                (showHideActivity)="store.setShowActivity({ profileCode: result.profileCode, showActivity: $event })"
                (loadLatestReview)="store.getLatestReviewEffect(result.profileCode)"
                (contact)="onContact(result.profileCode)" />
            }
          </div>
        } @else {
          <rma-result-table
            [agents]="results"
            [locality]="state.locality"
            [activeLocality]="state.activeLocality"
            (seletedLocality)="store.patchState({ activeLocality: $event })"
            (agentSelected)="onAgentSelectedFromTableView($event)" />
        }
        @if ((store.loading$ | async) === false) {
          <rma-results-paging
            class="mt-12 flex flex-col items-center space-y-4 pb-10 md:mt-16 md:pb-0"
            [saved]="store.saved$ | async"
            [savedMessage]="'findMyAgent.persistence.saved' | transloco"
            [canShowMore]="store.canShowMore$ | async"
            (showMore)="store.showMore()"
            (save)="store.saveEffect(true)" />
        }
        <p class="text-steel-80 mt-6 text-sm">{{ t('disclaimer') }}</p>
      }
    } @else {
      @if ((store.loading$ | async) === false) {
        <h2 class="mb-4 mt-8 text-3xl font-bold sm:text-4xl lg:mt-12">{{ t('no-results-header') }}</h2>
        <p>{{ t('no-results') }}</p>
      }
    }
    @if (store.contact$ | async; as contact) {
      <section class="border-steel-20 my-8 rounded border" [id]="contactFormId">
        <header class="h-8 w-full">
          <rma-branded-header
            class="h-full rounded-t"
            [background]="contact.branding.backgroundColour"
            [logo]="contact.branding.bannerImage" />
        </header>
        <div class="flex justify-center p-6">
          <div class="flex flex-col">
            <rma-result-profile
              class="mb-6"
              [avatar]="contact.branding.avatarImage"
              [name]="contact.name"
              [agencyName]="contact.agencyName" />
            <rma-results-contact-form
              [contact]="contact"
              [submittingStatus]="store.contactSubmitting$ | async"
              (contactRequest)="store.sendContactEffect($event)" />
            @if (store.contactError$ | async; as error) {
              <rma-callout class="m-4" [message]="error" />
            }
          </div>
        </div>
      </section>
    }
  }
</div>

<footer class="mx-auto py-10 md:max-w-7xl">
  <rma-results-footer class="flex flex-col items-center justify-center md:mx-6 md:flex-row xl:mx-auto" />
</footer>
